module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_03_6NX26_1SF_H1Y.151561e9.jpg";